<ng-container *ngIf="isVisible && action?._visible">
  <button type="button" nz-button *ngIf="action?.actionType === 'CHECK'" nz-tooltip
  [nzTooltipTitle]="action.actionTitle" nzTooltipPlacement="topCenter" [disabled]="disabled" (mousedown)="onActivate()">
  <i class="{{ isActive ? 'icmn-checkbox-checked' : 'icmn-checkbox-unchecked' }}"></i>
  <span>&nbsp; {{ action.actionTitle }}</span>
</button>
<button type="button" nz-button *ngIf="action?.actionType === 'STANDARD'" nz-tooltip
  [nzTooltipTitle]="action.actionTitle" nzTooltipPlacement="topCenter" [disabled]="disabled" (mousedown)="onActivate()">
  <i class="{{ icon }}"></i>
  <span *ngIf="action.iconName === '' || action.actionType === 'SELECT'">
    &nbsp; {{ action.actionTitle }}
  </span>
</button>
</ng-container>